import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { getButtonStyles } from '../../styles/constants';

interface CustomButtonProps extends Omit<ButtonProps, 'sx' | 'variant'> {
  variant?: 'primary' | 'secondary' | 'outlined';
  size?: 'small' | 'medium' | 'large';
}

const CustomButton: React.FC<CustomButtonProps> = ({ 
  variant = 'primary',
  size = 'large',
  ...props 
}) => {
  const getSxStyles = () => {
    const baseStyles = getButtonStyles(variant);
    const sizeStyles = {
      height: size === 'large' ? '56px' : size === 'medium' ? '48px' : '40px',
      px: size === 'large' ? 4 : size === 'medium' ? 3 : 2,
    };

    return {
      ...baseStyles,
      ...sizeStyles,
    };
  };

  return (
    <Button
      {...props}
      sx={getSxStyles()}
    />
  );
};

export default CustomButton;
